React = require 'react'
createReactClass = require 'create-react-class'
PropTypes = require 'prop-types'
R = require 'ramda'
ReactBacon = require 'react-bacon'

customerStore = require "stores/customer"

Globalize = require 'globalize'
{ FormatMessage } = require 'react-globalize'

Marketing = createReactClass
  displayName: 'Marketing'
  mixins: [ ReactBacon.BaconMixin ]

  props:
    order: PropTypes.object.isRequired
    locale: PropTypes.object.isRequired

  getInitialState: ->
    marketing: null

  componentDidMount: ->
    @plug customerStore.marketing, 'marketing'

  onSetMarketing: (event) ->
    marketing = @refs.marketing.checked
    customerStore.setMarketing marketing
    @setState marketing: marketing

  render: ->
    if @state.marketing != null
        <div className="panel panel-center" onClick={@onSetMarketing}>
        <div className="panel-body">
            <strong>
            <label htmlFor="marketing_opt_in">
                <input ref="marketing" type="checkbox" id="marketing_opt_in" value={@state.marketing} onChange={@onSetMarketing} />{ ' ' }
                <FormatMessage>order.customer.marketing</FormatMessage>
            </label>
            </strong>
        </div>
        </div>
    else
        null

module.exports = { Marketing }
